import { RadioIndicator } from '@mantine/core'
import classes from './styles.module.css'

export default RadioIndicator.extend({
    defaultProps: {
        size: 'md',
        color: 'var(--mercy-primary)',
    },
    classNames: { indicator: classes.indicator },
})
